import { render, staticRenderFns } from "./CanvasPage.vue?vue&type=template&id=52184a13&scoped=true&"
import script from "./CanvasPage.vue?vue&type=script&lang=js&"
export * from "./CanvasPage.vue?vue&type=script&lang=js&"
import style0 from "./CanvasPage.vue?vue&type=style&index=0&id=52184a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52184a13",
  null
  
)

export default component.exports